export default __webpack_public_path__ + "navigation-examples-offline-regions-960-6750f567c0f4bf6d38707f9fdcc04120.png";